import currencyFormatter from 'currency-formatter';
import Paper from 'material-ui/Paper';
import { withStyles } from 'material-ui/styles';
import Table, { TableBody, TableCell, TableFooter, TablePagination, TableRow } from 'material-ui/Table';
import { Typography, Checkbox } from 'material-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import ReservationStatusRender from '../../Reservation/ReservationStatusRender';
import { tableSortFunction } from '../../Utils/tableSortFunction';
import ReservationsTableHeader from './ReservationsTableHeader';
import ReservationsTableToolbar from './ReservationsTableToolbar';
import ReservationsTableMenu from './ReservationsTableMenu';
import { exportToXLS } from '../../Utils/exportToXLS';
import { exportToPDF } from '../../Utils/exportToPDF';
import { netPrice } from '../../../defaultValues/netPrice';
import getValue from '../../../defaultValues/getValue';
import DynIcon from '../../Utils/DynIcon';
import insuranceLogo from '../../../assets/logo_im.svg';
import { getPaymentToken } from '../reservationsServices';
import InformationPanel from '../../../ui/InformationPanel';


const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3
    },
    table: {
        minWidth: 800,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    bookingLocator: {
        color: 'var(--primary-color)'
    }
});

class ReservationsTable extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.currentUser = JSON.parse(localStorage.getItem('user'));
        this.onlyShowPvpPrice = !getValue(netPrice, this.currentUser.accountName.toLowerCase());

        this.state = {
            order: 'asc',
            orderBy: 'id',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 10,
            anchorEl: null,
            B2bVerPVP: this.currentUser.authorities.includes('B2bVerPVP'),
            pendingPayments: []
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.setState({page: 0});
            this.initializePendingPayments(this.props.data);
        }
    }

    initializePendingPayments(reservations) {
        const pendingPayments = reservations.map(reservation => ({ ...reservation, checked: false }));
        this.setState({ pendingPayments: pendingPayments });
    }

    /**
     * Sort Table data.
     * @param {type} event
     * @param {String} property column id
     */
    handleRequestSort = (event, property, columnsDataArray) => {
        const colDef = columnsDataArray.find(col => col.id === property);
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data = tableSortFunction(this.props.data, order, colDef);
        this.setState({ data, order, orderBy });
    };

    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({ selected: this.state.data.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    getTypeReservation = booking => {
        const { t } = this.props;
        if (booking.type === 'Hotel' && !booking.associatedTransfers.length && !booking.hotel.cancellationInsuranceAcepted) {
            return t('COMMON.HOTEL');
        }
        if (booking.type === 'DirectionsBus' && !booking.hotel && booking.transfer) {
            return t('COMMON.DIRECTIONSBUS');
        }
        if (booking.type === 'Hotel' && booking.associatedTransfers.length && !booking.hotel.cancellationInsuranceAcepted) {
            return t('COMMON.HOTEL') + '+' + t('COMMON.DIRECTIONSBUS');
        }
        if (booking.type === 'Hotel' && !booking.associatedTransfers.length && booking.hotel.cancellationInsuranceAcepted) {
            return t('COMMON.HOTEL') + '+' + t('COMMON.INSURANCE');
        }
        if (booking.type === 'Hotel' && booking.associatedTransfers.length && booking.hotel.cancellationInsuranceAcepted) {
            return t('COMMON.HOTEL') + '+' + t('COMMON.DIRECTIONSBUS') + t('COMMON.INSURANCE');
        }
    }

    exportList = (format) => {
        const { t } = this.props;
        let bookings = JSON.parse(localStorage.getItem('reservas'));
        if (bookings) {

            let B2bVerPVP = JSON.parse(localStorage.getItem('user')).authorities.includes('B2bVerPVP');
            let mustHideAgency = !bookings[0].agency.mustShowInReservationList;
            let priceLabel = t('BOOKINGS.PRICE');
            if (B2bVerPVP) {
                if (this.onlyShowPvpPrice) {
                    priceLabel = t('COMMON.AMOUNT');
                }
                else {
                    priceLabel = t('BOOKINGS.PVP');
                }
            }

            let headers = [
                t('BOOKINGS.TYPE'),
                t('BOOKINGS.LOCATOR'),
                t('BOOKINGS.AGENCY'),
                t('BOOKINGS.BOOKING_DATE'),
                t('BOOKINGS.AGENCY_LOCATOR'),
                t('COMMON.CHECK_IN'),
                t('COMMON.CHECK_OUT'),
                t('COMMON.HOTEL'),
                t('BOOKINGS.CLIENT'),
                priceLabel,
                t('BOOKINGS.STATE')
            ];

            let bookinsToExport = bookings.map(booking => {
                let price = B2bVerPVP ? booking.pvp : booking.price;
                price = format.toUpperCase() === 'PDF' ? price + ' EUR' : price;

                return {
                    'type': this.getTypeReservation(booking),
                    'olympiaLocator': booking.olympiaLocator,
                    'agency': booking.agencyCode,
                    'creationDate': booking.creationDate,
                    'clientLocator': booking.clientLocator,
                    'checkIn': booking.checkIn,
                    'checkOut': booking.checkOut,
                    'hotel': booking.hotel ? booking.hotel.name : '',
                    'holder': booking.holder.name + ' ' + booking.holder.lastname,
                    'price': price,
                    'state': this.getBookingState(booking)
                };
            });

            if (mustHideAgency) {
                headers = [headers[0]].concat(headers.slice(2));
                bookinsToExport.map(booking => delete booking.agency);
            }

            switch (format.toUpperCase()) {
                case 'PDF':
                    exportToPDF(bookinsToExport, headers, 'Bookings', true);
                    break;
                case 'XLS':
                    exportToXLS(bookinsToExport, headers, 'Bookings', 'Bookings');
            }

            return;
        }
    }

    getBookingState = (booking) => {
        const { state, paymentStatus } = booking;
        const bookingStatusName = {
            C: this.props.t('BOOKINGS.STATE_CANCELED'),
            R: this.props.t('BOOKINGS.STATE_BOOKED'),
            P: this.props.t('BOOKINGS.STATE_ON_REQUEST'),
            F: this.props.t('BOOKINGS.STATE_BILLED')
        };
        if (paymentStatus === 'PAYED') {
            return bookingStatusName[state.toUpperCase()] + ' / ' + this.props.t('COMMON.PAYED');
        } else {
            return bookingStatusName[state.toUpperCase()];
        }
    }

    getFlagImage = (code) => {
        if (code === 'NT') {
            return 'https://via.placeholder.com/24x18&text=INT';
        }
        return 'https://www.countryflags.io/' + String(code).toLowerCase() + '/flat/24.png';
    }

    getPriceFormatted(reservation, cancellationInsurance) {
        const price = cancellationInsurance && cancellationInsurance.active === 'SI' ? Number(reservation.price) + Number(cancellationInsurance.price) : Number(reservation.price);
        const priceFormatted = cancellationInsurance && cancellationInsurance.active === 'SI' ?
            currencyFormatter.format(parseFloat(price), { code: 'EUR' }) : currencyFormatter.format(parseFloat(reservation.price), { code: 'EUR' });
        return priceFormatted;
    }

    getPVPFormatted(reservation, cancellationInsurance) {
        const pvp = cancellationInsurance && cancellationInsurance.active === 'SI' ? Number(reservation.pvp) + Number(cancellationInsurance.pvp) : Number(reservation.pvp);
        const pvpFormatted = currencyFormatter.format(parseFloat(pvp), { code: 'EUR' });
        return pvpFormatted;
    }

    onCheckboxChange(olympiaLocator) {
        const { pendingPayments } = this.state;
        const idx = pendingPayments.findIndex(p => p.olympiaLocator === olympiaLocator);
        pendingPayments[idx].checked = !pendingPayments[idx].checked;
        this.setState({ pendingPayments: pendingPayments });
    }

    handlePayments() {
        const reservationsToPay = this.state.pendingPayments.filter(p => p.checked);
        this.firePaymentToken(reservationsToPay);  
        // const location = {
        //     pathname: '/hotels/reservations-pending-payments',
        //     state: { pendingPayments: reservationToPay, t: this.props.t }
        // };
        // this.props.history.push(location);
    }

    async handleSinglePayment(reservation) {
        this.firePaymentToken([reservation]);        
    }

    firePaymentToken = (reservations) => {

        this.setState((prevState, props) => {
            return { hideIcon: false, processing: false, operationstatus: 'info', mode: 'indeterminate' };
        });
        const secure3D = reservations.some(p => p.pendingPayment.secure3d);
        const totalPrice = reservations && reservations.length ? reservations.reduce((acc, val) => (acc + val.pendingPayment.price), 0) : 0;
        const options = {
            description: 'Olympia',
            amount: Math.trunc((totalPrice * 100).toFixed(0)),
            urlOk: `${window.location.origin}/#/bookings/payment-confirm?h={hash}`,
            urlKo: `${window.location.origin}/#/bookings/payment-error?h={hash}`,
        };
        return getPaymentToken(reservations, options, secure3D)
            .then(async ({ token: iframeToken, merchantOperation }) => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
                await this.setState(() => ({
                    iframeToken,
                    hideIcon: false,
                    merchantOperation,
                    processing: false,
                    loading: false
                }));

                const location = {
                    pathname: '/hotels/reservations-pending-payments',
                    state: { pendingPayments: reservations, iframeToken, merchantOperation, t: this.props.t }
                };
                this.props.history.push(location);

            })
            .catch((err) => {
                this.setState({
                    operationstatus: 'error',
                    hideIcon: false,
                    processing: true,
                    operationtitle: this.props.t('PENDING_PAYMENTS.TOKEN_ERROR'),
                    operationtext: '',
                    mode: 'buffer',
                    completed: 100
                });
            });
    }

    isChecked(olympiaLocator) {
        const { pendingPayments } = this.state;
        return pendingPayments && pendingPayments.find(p => p.olympiaLocator === olympiaLocator) && pendingPayments.find(p => p.olympiaLocator === olympiaLocator).checked;
    }

    render() {
        const { classes, t } = this.props;
        const { order, orderBy, selected, rowsPerPage, page, pendingPayments } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, this.props.data.length - page * rowsPerPage);
        return (
            <Paper className={classes.root}>
                <ReservationsTableToolbar
                    numSelected={selected.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    data={this.props.data}
                    pendingPayments={this.state.pendingPayments}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    actionHandler={this.exportList}
                    onPayReservations={() => this.handlePayments()}
                />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table + "  CmsMyReservationTable"}>
                        <ReservationsTableHeader
                            numSelected={selected.length}
                            user={this.props.user}
                            clientName={this.props.clientName}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={this.handleSelectAllClick}
                            onRequestSort={this.handleRequestSort}
                            rowCount={this.props.data.length}
                            onlyShowPvpPrice={this.onlyShowPvpPrice}
                            t={this.props.t}
                        />
                        <TableBody >
                            {this.props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                const isSelected = this.isSelected(n.id);
                                const { cancellationInsurance } = n && n.hotel ? n.hotel : {};
                                const priceFormatted = this.getPriceFormatted(n, cancellationInsurance);
                                const pvpFormatted = this.getPVPFormatted(n, cancellationInsurance);
                                const isPending = pendingPayments && pendingPayments.length && n.pendingPayment && n.paymentStatus && n.paymentStatus === 'PAYED' && n.pendingPayment.price > 0 && n.state === 'R';
                                
                                return (
                                    <TableRow
                                        hover                                       
                                        aria-checked={isSelected}
                                        tabIndex={-1}
                                        key={n.id}
                                        selected={isSelected}>
                                        <TableCell className="cmsMyBCheckbox" padding={'none'} >
                                            {   isPending &&
                                                <Checkbox
                                                    value={n.olympiaLocator}
                                                    style={{ width: 36, height: 36 }}                                                    
                                                    onChange={event => this.onCheckboxChange(event.target.value)}
                                                    checked={this.isChecked(n.olympiaLocator)} />
                                            }
                                        </TableCell>
                                        <TableCell className="cmsBookingType" padding={'none'} >
                                            <DynIcon icon={n.type} style={{ color: 'var(--primary-color)', marginLeft: 5, width: '20px', height: '20px' }} />
                                            {n.associatedTransfers.length > 0 ?
                                                <DynIcon icon="DirectionsBus" style={{ color: 'var(--primary-color)', width: '20px', height: '20px' }} /> :
                                                ''}
                                            {cancellationInsurance && cancellationInsurance.active === 'SI' &&
                                                <span>
                                                    <DynIcon icon='Add' style={{ color: 'var(--primary-color)', marginLeft: 5 ,width: '0.85rem'}} />
                                                    <img style={{ width: '1rem', marginLeft: '5px' }} src={insuranceLogo} alt='' />
                                                </span>
                                            }
                                        </TableCell>
                                        <TableCell padding={'none'}>
                                            <a href={'#/bookings/' + n.olympiaLocator + '/view'}
                                                className={classes.bookingLocator} target='_blank' rel='noopener noreferrer'>
                                                <b>{n.olympiaLocator}</b>
                                            </a>
                                        </TableCell>
                                        {this.props.clientName === 'B2BWebOlympia' ?
                                            <TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>
                                                <img title={n.market.label} alt={n.market.code} width='24'
                                                    src={this.getFlagImage(n.market.code)} align="middle" />
                                            </TableCell> : ''
                                        }
                                        {n.mustShowInReservationList ? (
                                            <TableCell padding={'none'}>{n.clientComercialName}</TableCell>
                                        ) : (
                                                ''
                                            )}

                                        <TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>{n.creationDate}</TableCell>
                                        <TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>{n.clientLocator}</TableCell>
                                        <TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>{n.checkIn}</TableCell>
                                        <TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>{n.checkOut}</TableCell>
                                        <TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>{n.hotel ? n.hotel.name : ''}</TableCell>
                                        <TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>
                                            {n.holder ? n.holder.name + ' ' + n.holder.lastname : n.holderName}
                                        </TableCell>

                                        {
                                            this.state.B2bVerPVP ? (
                                                <TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>
                                                    <strong>{pvpFormatted}</strong>
                                                </TableCell>)
                                                : (
                                                    <TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>
                                                        <strong>{priceFormatted}</strong>
                                                    </TableCell>)

                                        }
                                        {n.pendingPayment ?
                                            (<TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>
                                                <strong>{currencyFormatter.format(parseFloat(n.pendingPayment.price), { code: 'EUR' })}</strong>
                                            </TableCell>)
                                            :
                                            (<TableCell padding={'none'} style={{ paddingLeft: '14px', fontWeight: 300 }}>
                                                <strong>{currencyFormatter.format(parseFloat('0.00'), { code: 'EUR' })}</strong>
                                            </TableCell>)
                                        }
                                        <TableCell padding={'none'} style={{ textAlign: 'center' }}>
                                            {n.allowedActions ? (
                                                <ReservationsTableMenu
                                                    options={n.allowedActions}
                                                    isPending={isPending}
                                                    reservation={n}
                                                    actionhandler={this.props.actionhandler}
                                                    onPayReservation={() => this.handleSinglePayment(n)}
                                                    labels={this.props.menuactionslabels}
                                                />
                                            ) : (
                                                    ''
                                                )}
                                        </TableCell>
                                        <TableCell padding={'none'} >
                                            <div style={{ margin: '0 auto' }}>
                                                {n && n.state ? <ReservationStatusRender showPaymentStatus={true} reservation={n} /> : ''}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 49 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    count={this.props.data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    labelRowsPerPage={t('BOOKINGS.SHOWING')}
                                    labelDisplayedRows={({ from, to, count }) => `${from} - ${to} ${t('BOOKINGS.FROM')} ${count}`}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
                <div className="cmsPendingPayments">
                <div className="cmsContainer">
                {this.state.processing &&
                        <InformationPanel
                            hideIcon={this.state.hideIcon}
                            type={this.state.operationstatus}
                            title={this.state.operationtitle}
                            onCancel={e => { this.setState({ hideIcon: false, processing: false }); }}
                            text={this.state.operationtext}>
                        </InformationPanel>
                    }
                    </div>
                    </div>
            </Paper>
        );
    }
}

ReservationsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    clientName: PropTypes.string.isRequired
};

export default translate('translations')(withStyles(styles)(ReservationsTable));




// WEBPACK FOOTER //
// ./src/components/Reservations/Table/ReservationsTable.js